import * as XLSX from "xlsx";
import posService from "../../services/pos/pos.service";

interface PosInventoryReportDTO {
  posId: number;
  posCode: string;
  productName: string;
  quantity: number;
  value: number;
}

export const exportPOSInventoryExcel = async (
  selectedPOS: number[],
  selectedProducts: number[]
) => {
  try {
    const response = await posService.getPOSInventoryExcel({
      posIds: selectedPOS,
      productIds: selectedProducts,
    });
    const generatedAt = new Date().toLocaleString();

    const processedData = generatePOSInventoryExcelData(
      response,
      selectedPOS,
      generatedAt
    );

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(processedData);

    XLSX.utils.sheet_add_aoa(
      ws,
      [["POSID", "Product Name", "Quantity", "Value(No Tax Included)", "Generated At"]],
      { origin: "A1" }
    );

    XLSX.utils.book_append_sheet(wb, ws, "POS Inventory Report");
    XLSX.writeFile(wb, "POSInventoryReport.xlsx");
  } catch (error) {
    console.error("Error exporting POS inventory report:", error);
  }
};

const generatePOSInventoryExcelData = (
  apiData: PosInventoryReportDTO[],
  selectedPOS: number[],
  generatedAt: string
) => {
  const result: any[] = [];

  selectedPOS.forEach((posId) => {
    const posProducts = apiData.filter((item) => item.posId === posId);

    posProducts.forEach((prod) => {
      result.push({
        POSID: prod.posCode,
        "Product Name": prod.productName,
        Quantity: prod.quantity,
        Value: prod.value,
        "Generated At": generatedAt,
      });
    });
  });

  return result;
};
